import { useSearchParams, Link } from "react-router-dom";

export default function RejectedPage() {
  const [sp] = useSearchParams();
  const email = sp.get("email");

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "linear-gradient(135deg, #f5f7fa 0%, #f7e4e4 100%)", padding: 20 }}>
      <div data-testid="rejected-page" style={{ maxWidth: 480, width: "100%", background: "white", borderRadius: 8, boxShadow: "0 8px 32px rgba(0,0,0,0.1)", overflow: "hidden" }}>
        <div style={{ background: "linear-gradient(135deg, #c62828, #b71c1c)", color: "white", padding: "20px 24px", textAlign: "center" }}>
          <div style={{ fontSize: 40, marginBottom: 6 }}>🚫</div>
          <div style={{ fontSize: 18, fontWeight: 700 }}>Accesso negato</div>
        </div>
        <div style={{ padding: 28, fontSize: 13, color: "#444", lineHeight: 1.55 }}>
          <p style={{ marginTop: 0 }}>
            L'account {email && <b>{email}</b>} non è abilitato ad accedere a <b>canossaHUB</b>.
          </p>
          <p>Se ritieni che si tratti di un errore contatta l'amministratore.</p>
          <div style={{ display: "flex", gap: 10, marginTop: 22 }}>
            <Link data-testid="btn-back-home" to="/" style={{ flex: 1, textAlign: "center", padding: "10px 14px", background: "#0066cc", color: "white", textDecoration: "none", borderRadius: 2, fontWeight: 600, fontSize: 12 }}>Torna alla home</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
